import { render, staticRenderFns } from "./VideoFeed.vue?vue&type=template&id=9478c660&"
import script from "./VideoFeed.vue?vue&type=script&lang=js&"
export * from "./VideoFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports